import Field from "./_Field";

export default class RadioGroupField extends Field
{

  static findAllFieldsInForm(form){
    const inputsEls = form.querySelectorAll('input[type=radio]');
    const inputs = {};
    for (let el of inputsEls){
      if (!(el.name in inputs)) inputs[el.name] = [];
      inputs[ el.name ].push(el) ;
    }
    return inputs;
  }

  getValue(){
    for (let el of this.el){
      if (el.checked) return el.value;
    }
    return undefined;
  }

}
